export default "/images/faf61d85dac12e5483d95124a9cb7c38.png";